importDashboardCtrl.$inject = ['completedImports', 'incompleteImports', 'adminApi', '$scope']

export default function importDashboardCtrl(completed, incomplete, adminApi, $scope) {
  if (completed.status === 'error') {
    this.completedErrorMessage = completed.message
  } else {
    this.completedImports = completed
  }
  if (incomplete.status === 'error') {
    this.incompleteErrorMessage = incomplete.message
  } else {
    this.incompleteImports = incomplete
  }

  this.fetching = false
  
  this.onAutoprovisioningTabSelect = function() {
    $scope.$broadcast('autoprovisioningTabSelected')
  }
}
